import React, { useState, useContext, useEffect } from "react";
import {
  ManageMastersLayout,
  SearchComponent,
  SliderPanel,
} from "../../../components";
import { Button } from "react-bootstrap";
import { faSort } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClearingPartnerDetailsTile from "./ClearingPartnerDetailsTile";
import { ClearingPartnerDetailsSlider } from "./ClearingPartnerDetailsSlider";
import { useRequest, useDeepEffect } from "../../../abstracts";
import { manageMasterStore } from "../../../contexts";
import { GetTradingPartner, DeleteClearingPartner } from "../../../services";
import { get, isEmpty } from "lodash";
import { ClearingPartnerCreateEditSlider } from "./ClearingPartnerCRUContainer";
const ClearingPartnerDetailsContainer = (props) => {
  const { state, dispatch } = useContext(manageMasterStore);
  const [slider, setSlider] = useState(false);
  const [create, setCreate] = useState(false);
  const [editOpen, setIsEdit] = useState(false);

  const [sliderData, setSliderData] = useState({});
  const [clearingPartnerAccounts, setClearingPartnerDetails] = useState(
    get(state, "clearingPartnerDetail.clearingPartnerListResponses", [])
  );
  const clearingPartnerId = get(state, "clearingPartnerId");
  console.log(
    state,
    clearingPartnerId,
    get(state, "clearingPartnerDetail.clearingPartnerListResponses", []),
    "state"
  );
  useDeepEffect(() => {
    if (clearingPartnerId) {
      GetTradingPartner(clearingPartnerId)
        .then((response) => {
          console.log("response", response);
          setClearingPartnerDetails(response.clearingPartnerListResponses);
        })
        .catch((error) => {});
    }
  }, [editOpen]);
  useDeepEffect(() => {
    if (get(state, "clearingPartnerDetail.clearingPartnerListResponses", [])) {
      setClearingPartnerDetails(
        get(state, "clearingPartnerDetail.clearingPartnerListResponses", [])
      );
    }
  }, [state]);
  const createPartner = () => {
    setIsEdit(!editOpen);
    setCreate(!create);
    setSliderData({});
  };
  const setEdit = () => {
    setIsEdit(!editOpen);
    setCreate(false);
  };
  const onSearchChange = (val) => {
    const accs = get(
      state,
      "clearingPartnerDetail.clearingPartnerListResponses",
      []
    )?.filter(
      (e) => e.clearingPartnerId.includes(val) || e.bankName.includes(val)
    );
    setClearingPartnerDetails(accs);
  };
  console.log("clearingPartnerAccounts", state);

  // console.log(clearingPartnerAccounts, "clearingPartnerAccounts");
  return (
    <ManageMastersLayout layoutHeader="Manage Clearing Partner Account">
      <div className="clearing-partner-details-container">
        <SearchComponent
          placeholder="Search by clearing partner ID, bank name"
          className="search-component-clearing-partner"
          onSearchChange={onSearchChange}
        />
        <div className="header-label">
          <div className="clearing-partner-subjects">
            <div className="clearing-partner-recently-added">
              Recently Added/Modified
            </div>
            <div className="clearing-partner-records">
              {clearingPartnerAccounts.length} Records found
            </div>
          </div>
          <Button variant="primary" onClick={createPartner}>
            Create Partner Account ID
          </Button>
        </div>
        <div className="clearing-partner-table">
          <div className="header-clearing-partner w-40">
            <div className="table-header-clearing-partner">
              Clearing Partner ID
            </div>
          </div>
          <div className="header-clearing-partner w-20">
            <div className="table-header-clearing-partner">No of Plans</div>
          </div>
          <div className="header-clearing-partner w-30">
            <div className="table-header-clearing-partner">Bank details</div>
          </div>
          <div className="header-clearing-partner w-10">
            <div className="table-header-clearing-partner">Actions</div>
          </div>
        </div>
        <div className="clearing-partner-detail-tiles">
          {clearingPartnerAccounts?.map((e, i) => {
            return (
              <ClearingPartnerDetailsTile
                setSlider={setSlider}
                data={e}
                clearingPartnerId={get(state, "clearingPartnerDetail.id", 0)}
                setEdit={setEdit}
                setSliderData={setSliderData}
                setClearingPartnerDetails={setClearingPartnerDetails}
                key={i}
              />
            );
          })}
        </div>
      </div>

      <SliderPanel
        isOpen={editOpen}
        size={30}
        showCancel={false}
        onClose={setEdit}
        backdropClicked={setEdit}
      >
        <ClearingPartnerCreateEditSlider
          dispatch={dispatch}
          setEdit={setEdit}
          create={create}
          data={sliderData}
          clearingPartnerId={get(state, "clearingPartnerDetail.id", 0)}
        />
      </SliderPanel>
    </ManageMastersLayout>
  );
};

export default ClearingPartnerDetailsContainer;
